export default __webpack_public_path__ + "static/article_feature-a5af13f15460d16dd31b5593f4f9c7dd.jpg";